var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedicalRecordsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F0F2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2859 14.5715H30.8573C31.3119 14.5715 31.748 14.7522 32.0695 15.0736C32.3909 15.3951 32.5716 15.8312 32.5716 16.2858V33.4287C32.5716 33.8833 32.3909 34.3194 32.0695 34.6408C31.748 34.9623 31.3119 35.143 30.8573 35.143H17.143C16.6883 35.143 16.2523 34.9623 15.9308 34.6408C15.6093 34.3194 15.4287 33.8833 15.4287 33.4287V16.2858C15.4287 15.8312 15.6093 15.3951 15.9308 15.0736C16.2523 14.7522 16.6883 14.5715 17.143 14.5715H19.7144",
    stroke: "#001184",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5715 12.8572H21.4286C20.4819 12.8572 19.7144 13.6247 19.7144 14.5715V15.4286C19.7144 16.3754 20.4819 17.1429 21.4286 17.1429H26.5715C27.5183 17.1429 28.2858 16.3754 28.2858 15.4286V14.5715C28.2858 13.6247 27.5183 12.8572 26.5715 12.8572Z",
    stroke: "#001184",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8046 20.9314C22.3981 20.9314 22.0685 21.261 22.0685 21.6675V23.7378H19.9983C19.5918 23.7378 19.2622 24.0673 19.2622 24.4738V26.8661C19.2622 27.2727 19.5918 27.6022 19.9983 27.6022H22.0685V29.6724C22.0685 30.0789 22.3981 30.4086 22.8046 30.4086H25.1969C25.6034 30.4086 25.933 30.0789 25.933 29.6724V27.6022H28.0032C28.4098 27.6022 28.7393 27.2727 28.7393 26.8661V24.4738C28.7393 24.0673 28.4098 23.7378 28.0032 23.7378H25.933V21.6675C25.933 21.261 25.6034 20.9314 25.1969 20.9314H22.8046Z",
    stroke: "#001184",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalRecordsIcon);
export default __webpack_public_path__ + "static/media/medical-records-icon.94e3b06adb4d86123f5e959a0a3de3e0.svg";
export { ForwardRef as ReactComponent };